import { RegisteredProduct } from '~/models/warranty/RegisteredProduct'

export class WarrantyState {
  public products: RegisteredProduct[] = []
}

export default (): WarrantyState => new WarrantyState()
